import styled from 'styled-components';

import { CalciteInput, CalciteNotice } from 'components/Calcite';

import Select from 'components/Select';
import { Heading, Paragraph } from 'components/StyledComponents';
import DataGrid, { DataGridCell, DataGridRow } from 'components/DataGrid';

export const StyledMetricsTable = styled(DataGrid)`
  table-layout: fixed;

  label {
    min-width: 0;
  }
`;

export const InputCell = styled(DataGridCell)`
  height: 45px;
  box-sizing: border-box;
`;

export const DisplayCell = styled(DataGridCell)`
  background-color: ${({ theme }) => theme.color.foreground1};
  font-family: ${({ theme }) => theme.font.codeFamily};
`;

export const StyledSelect = styled(Select)`
  --calcite-color-border-input: ${({ theme }) => theme.color.foreground1};
`;

export const NumberOfFeaturesCell = styled(InputCell)`
  padding: 0 0.75em 0.2em 0.5em;
  display: flex;
  align-items: flex-end;
  border: none;
`;

export const StyledTextField = styled(CalciteInput)`
  --calcite-color-border-input: ${({ theme }) => theme.color.foreground1};
  border-bottom: 1px solid ${({ theme }) => theme.color.border2};
  flex: 1;
  min-width: 0; // Prevents error icon from getting pushed out of table cell
`;

/* export const StyledTextField = styled(TextField).attrs({
  minimal: true
})`
  flex: 1;
  margin: 0;
`; */

export const TimeUnitCell = styled(InputCell)`
  padding: 0;
`;

export const StyledTotalRow = styled(DataGridRow)`
  background-color: ${({ theme }) => theme.color.foreground1};
  border-top: 2px solid ${({ theme }) => theme.color.border1};
  font-size: 1.1rem;
`;

export const TotalCell = styled(DataGridCell)`
  height: 45px;
  font-weight: bold;
`;

export const TotalRateCell = styled(DisplayCell)`
  height: 45px;
`;

export const StyledHeading = styled(Heading)`
  text-align: center;
  margin: 2rem;
`;

export const StyledParagraph = styled(Paragraph)`
  text-align: center;
  margin: 2rem;
`;

export const StyledNotice = styled(CalciteNotice)`
  margin: auto;
`;
